/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ monthly_plan_price: NonNullable<unknown> }} New_User_Paywall_Footer_Free_Ver_MonthlyInputs */

const en_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totally free for 3 days, then billed monthly at ${i?.monthly_plan_price}. Cancel anytime.`)
};

const ar_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مجاني تمامًا لمدة 3 أيام، ثم يتم تحصيل الرسوم شهريًا بقيمة ${i?.monthly_plan_price}. يمكنك الإلغاء في أي وقت`)
};

const de_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`3 Tage lang kostenlos, danach monatliche Abrechnung von ${i?.monthly_plan_price}. Jederzeit kündbar.`)
};

const es_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totalmente gratis durante 3 días, luego se factura mensualmente a ${i?.monthly_plan_price}. Cancela en cualquier momento.`)
};

const fr_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`3 jours d'essai gratuit, puis facturé mensuellement à ${i?.monthly_plan_price}. Résiliez quand vous voulez.`)
};

const it_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Completamente gratuito per 3 giorni, poi fatturato mensilmente a ${i?.monthly_plan_price}. Annulla in qualsiasi momento.`)
};

const ja_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`3日間は完全無料、その後は月額 ${i?.monthly_plan_price} で請求されます。いつでもキャンセル可能です。`)
};

const ko_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`3일간 완전히 무료이며 이후에는 매달 ${i?.monthly_plan_price}씩 청구됩니다. 언제든지 취소할 수 있습니다.`)
};

const pt_br_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inteiramente grátis por 3 dias, depois cobrado mensalmente a ${i?.monthly_plan_price}. Cancele quando quiser.`)
};

const ru_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Абсолютно бесплатно в течение 3 дней, затем ежемесячная оплата в размере ${i?.monthly_plan_price}. Отмена в любое время.`)
};

const th_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี 3 วันเต็ม หลังจากนั้นเรียกเก็บเงินเป็นรายเดือน ${i?.monthly_plan_price} ยกเลิกได้ทุกเมื่อ`)
};

const tr_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`3 gün boyunca tamamen ücretsiz, ardından aylık ${i?.monthly_plan_price} karşılığında faturalandırılır. İstediğin zaman iptal edebilirsin.`)
};

const zh_cn_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 3 天完全免费，之后按月计费，每月 ${i?.monthly_plan_price}。可随时取消。`)
};

const zh_tw_new_user_paywall_footer_free_ver_monthly = /** @type {(inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 3 天完全免費，之後按月計費，每月 ${i?.monthly_plan_price}。可隨時取消。`)
};

/**
* | output |
* | --- |
* | "Totally free for 3 days, then billed monthly at {monthly_plan_price}. Cancel anytime." |
*
* @param {New_User_Paywall_Footer_Free_Ver_MonthlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const new_user_paywall_footer_free_ver_monthly = /** @type {((inputs: New_User_Paywall_Footer_Free_Ver_MonthlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_User_Paywall_Footer_Free_Ver_MonthlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "ar") return ar_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "de") return de_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "es") return es_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "fr") return fr_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "it") return it_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "ja") return ja_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "ko") return ko_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "pt_br") return pt_br_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "ru") return ru_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "th") return th_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "tr") return tr_new_user_paywall_footer_free_ver_monthly(inputs)
	if (locale === "zh_cn") return zh_cn_new_user_paywall_footer_free_ver_monthly(inputs)
	return zh_tw_new_user_paywall_footer_free_ver_monthly(inputs)
});